// @ts-strict-ignore
import { AfterViewInit, Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { uniqueId } from 'lodash-es';
import { Calendar } from 'primeng/calendar';
import { UI_STRINGS } from '../../../../functions/language/uistrings';
import { InputBaseComponent } from '../input-base/input-base.component';

@Component({
    selector: 'ui-input-date',
    templateUrl: './input-date.component.html',
    styleUrls: ['./input-date.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InputDateComponent extends InputBaseComponent<Date> implements OnInit, AfterViewInit {
  @Input() dateFormat: string;
  @Input() errorMessage: string = UI_STRINGS.INPUT_COMPONENTS.DATE_INVALID;
  @Input() footerMessage: string;
  @Input() maxDate: Date = new Date(2100, 11, 31);
  @Input() minDate: Date = new Date(1900, 0, 1);
  @Input() name: string = uniqueId('date');
  @Input() placeholder: string;
  @Input() view: 'date' | 'month' | 'year' = 'date';

  @ViewChild('calendar', { static: false }) calendar: Calendar;

  private _cachedInput: string;
  private _cachedValue: Date;

  get currentErrorMessage(): string {
    return this.touchedButRequired ? UI_STRINGS.GLOBAL.REQUIRED_NOTE : this.errorMessage;
  }

  get isInvalidDate(): boolean {
    const inputFieldValue = this.calendar?.inputfieldViewChild.nativeElement.value;
    return (
      (!this.value && !!inputFieldValue) ||
      this.value > this.maxDate ||
      this.value < this.minDate ||
      this.touchedButRequired
    );
  }

  get touchedButRequired(): boolean {
    return this.control?.touched && !this.control.value && (this.required || this.control.errors?.requiredIfOther);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this._cachedValue = this.control.control.value;
  }

  ngAfterViewInit(): void {
    if (this.autofocus) {
      setTimeout(() => {
        //delay to ensure layout is completed and so that the fold out is placed correctly.
        //additional delay since it is used in the action editor to not focus when the fold out animation is playing.
        this.focus();
      }, 100);
    }
  }

  focus(): void {
    this.calendar.inputfieldViewChild.nativeElement.focus();
  }

  onBlur(): void {
    if (!this._cachedInput || !!this.value) {
      this._onChosenDate();
    }
  }

  onInput(event: InputEvent): void {
    this._cachedInput = (event.target as HTMLInputElement).value;
  }

  onLabelClick(event: MouseEvent): void {
    event.preventDefault();
  }

  onSelect(newDate: Date): void {
    this._cachedInput = undefined;
    this._onChosenDate(newDate);
  }

  private _onChosenDate(date?: Date): void {
    const oldDate = this._cachedValue;
    const newDate = date ?? this.value;
    if (oldDate?.getTime() === newDate?.getTime()) {
      return;
    }
    this._cachedValue = newDate;
    this.onChange(newDate);
    this.onTouched(newDate);
  }
}
